/**
 * 날짜(yyyy-mm-dd) → yyyy년 mm월 dd일 변환
 */
function formatDateToKorean(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${y}년 ${m}월 ${d}일`;
}
// 증권계좌 조회 완료 플래그
let accountLookedUp = false;
// 휴대폰 인증 완료 플래그
let phoneVerified = false;

/**
 * 숫자를 한글로 변환 (만원 단위 입력)
 */
function numberToKorean(num) {
  if (!num || num === 0) return '';
  
  // 입력값은 만원 단위이므로 원 단위로 변환
  num = num * 10000;
  
  const units = ['', '만', '억', '조'];
  const digit = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  
  let result = '';
  let unitIndex = 0;
  
  while (num > 0) {
    const part = num % 10000;
    if (part > 0) {
      let partStr = '';
      
      const thousand = Math.floor(part / 1000);
      const hundred = Math.floor((part % 1000) / 100);
      const ten = Math.floor((part % 100) / 10);
      const one = part % 10;
      
      if (thousand > 0) partStr += digit[thousand] + '천';
      if (hundred > 0) partStr += digit[hundred] + '백';
      if (ten > 0) partStr += digit[ten] + '십';
      if (one > 0) partStr += digit[one];
      
      result = partStr + units[unitIndex] + result;
    }
    
    num = Math.floor(num / 10000);
    unitIndex++;
  }
  
  return result + ' 원';
}

/**
 * 대출신청금액 입력 시 한글 금액 업데이트
 */
function updateKoreanAmount() {
  const amount = parseInt(document.getElementById('loanRequestAmount').value.replace(/[^0-9]/g, '')) || 0;
  const koreanAmount = numberToKorean(amount);
  document.getElementById('loanRequestAmountKorean').textContent = koreanAmount;
}

/**
 * 이메일 도메인 선택 변경 처리
 */
function handleEmailDomainChange() {
  const emailDomain = document.getElementById('emailDomain');
  const emailDomainSelectWrapper = document.getElementById('emailDomainSelectWrapper');
  const emailDomainInput = document.getElementById('emailDomainInput');
  
  if (emailDomain.value === 'direct') {
    // 직접입력 선택 시: select 숨기고 input 표시
    emailDomainSelectWrapper.style.display = 'none';
    emailDomainInput.style.display = 'block';
    emailDomainInput.focus();
  } else {
    // 다른 옵션 선택 시: input 숨기고 select 표시
    emailDomainInput.style.display = 'none';
    emailDomainSelectWrapper.style.display = 'block';
  }
}

/**
 * 휴대폰 인증 처리
 */
function verifyPhone2() {
  // 1단계: 고객정보 섹션 전체 검증
  
  // 성명: 한글, 영문, 숫자 가능 (필수)
  const customerName = document.getElementById('customerName').value.trim();
  if (!customerName) {
    alert('성명을 입력해주세요.');
    document.getElementById('customerName').focus();
    return;
  }
  const namePattern = /^[가-힣a-zA-Z0-9\s]+$/;
  if (!namePattern.test(customerName)) {
    alert('성명은 한글, 영문, 숫자만 입력 가능합니다.');
    document.getElementById('customerName').focus();
    return;
  }

  // 주민등록번호 앞자리: 숫자 6자리 (필수)
  const ssn1 = document.getElementById('ssn1').value.trim();
  if (!ssn1 || ssn1.length !== 6) {
    alert('주민등록번호 앞 6자리를 정확히 입력해주세요.');
    document.getElementById('ssn1').focus();
    return;
  }
  if (!/^[0-9]{6}$/.test(ssn1)) {
    alert('주민등록번호 앞자리는 숫자만 입력 가능합니다.');
    document.getElementById('ssn1').focus();
    return;
  }

  // 주민등록번호 뒷자리: 숫자 7자리 (필수)
  const ssn2 = document.getElementById('ssn2').value.trim();
  if (!ssn2 || ssn2.length !== 7) {
    alert('주민등록번호 뒤 7자리를 정확히 입력해주세요.');
    document.getElementById('ssn2').focus();
    return;
  }
  if (!/^[0-9]{7}$/.test(ssn2)) {
    alert('주민등록번호 뒷자리는 숫자만 입력 가능합니다.');
    document.getElementById('ssn2').focus();
    return;
  }

  // 우편번호: 숫자 5자리 (필수)
  const postcode = document.getElementById('postcode').value.trim();
  if (!postcode) {
    alert('우편번호를 입력해주세요.');
    document.getElementById('postcode').focus();
    return;
  }
  if (!/^[0-9]{5}$/.test(postcode)) {
    alert('우편번호는 5자리 숫자만 입력 가능합니다.');
    document.getElementById('postcode').focus();
    return;
  }

  // 기본주소: (필수)
  const address1 = document.getElementById('address1').value.trim();
  if (!address1) {
    alert('기본주소를 입력해주세요.');
    document.getElementById('address1').focus();
    return;
  }

  // 상세주소: 한글, 영문, 숫자 가능 (선택 입력이지만 입력 시 형식 검증)
  const address2 = document.getElementById('address2').value.trim();
  if (address2) {
    const addressPattern = /^[가-힣a-zA-Z0-9\s\-,./()]+$/;
    if (!addressPattern.test(address2)) {
      alert('상세주소는 한글, 영문, 숫자만 입력 가능합니다.');
      document.getElementById('address2').focus();
      return;
    }
  }

  // 이메일 전체 검증 (선택이지만 입력 시 완전한 이메일 주소여야 함)
  const emailId = document.getElementById('emailId').value.trim();
  const emailDomain = document.getElementById('emailDomain').value;
  const emailDomainInput = document.getElementById('emailDomainInput');
  
  // 이메일 아이디 또는 도메인 중 하나라도 입력된 경우, 완전한 이메일 주소 검증
  if (emailId || emailDomain) {
    // 이메일 앞자리 검증
    if (!emailId) {
      alert('정확한 이메일 주소를 확인해 주세요.');
      document.getElementById('emailId').focus();
      return;
    }
    
    const emailPattern = /^[a-zA-Z0-9._-]+$/;
    if (!emailPattern.test(emailId)) {
      alert('정확한 이메일 주소를 확인해 주세요.');
      document.getElementById('emailId').focus();
      return;
    }
    
    // 도메인 선택 확인
    if (!emailDomain) {
      alert('정확한 이메일 주소를 확인해 주세요.');
      document.getElementById('emailDomain').focus();
      return;
    }
    
    // 직접입력 선택 시 도메인 형식 검증
    if (emailDomain === 'direct') {
      const domainValue = emailDomainInput.value.trim();
      
      // 도메인 입력 여부 확인
      if (!domainValue) {
        alert('정확한 이메일 주소를 확인해 주세요.');
        emailDomainInput.focus();
        return;
      }
      
      // 도메인 형식 검증
      const domainPattern = /^[a-zA-Z0-9.-]+\.(com|net|org|co\.kr|kr|io|info|biz|edu|gov)$/;
      if (!domainPattern.test(domainValue)) {
        alert('정확한 이메일 주소를 확인해 주세요.');
        emailDomainInput.focus();
        return;
      }
    }
  }

  // 2단계: 통신사 및 휴대폰번호 검증 (필수)
  const carrier = document.getElementById('carrier').value;
  const phoneNumber = document.getElementById('phoneNumber').value.trim();
  
  // 통신사 선택 확인
  if (!carrier) {
    alert('통신사를 선택해주세요.');
    document.getElementById('carrier').focus();
    return;
  }
  
  // 휴대폰 번호 입력 확인
  if (!phoneNumber) {
    alert('휴대폰 번호를 입력해주세요.');
    document.getElementById('phoneNumber').focus();
    return;
  }
  
  // 휴대폰 번호 형식 확인
  if (!/^[0-9]{10,11}$/.test(phoneNumber)) {
    alert('휴대폰 번호는 10~11자리 숫자만 입력 가능합니다.');
    document.getElementById('phoneNumber').focus();
    return;
  }
  
  // 3단계: 모든 검증 통과 - 휴대폰 인증 API 호출
  // TODO: 실제 휴대폰 인증 API 연동
  
  // 테스트용 임시 인증 완료 처리
  phoneVerified = true;
  alert('휴대폰 인증이 완료되었습니다.');
  document.getElementById('phoneVerificationMessage').style.display = 'block';
}

/**
 * 증권계좌번호 조회
 */
function lookupStockAccount() {
  // 휴대폰 인증 완료 여부 확인
  if (!phoneVerified) {
    alert('필수 입력 사항을 확인하고 먼저 휴대폰 인증을 완료해주세요.');
    
    // 첫 번째 미입력 필수 항목으로 포커스 이동
    const customerName = document.getElementById('customerName').value.trim();
    if (!customerName) {
      document.getElementById('customerName').focus();
      return;
    }
    
    const ssn1 = document.getElementById('ssn1').value.trim();
    if (!ssn1 || ssn1.length !== 6) {
      document.getElementById('ssn1').focus();
      return;
    }
    
    const ssn2 = document.getElementById('ssn2').value.trim();
    if (!ssn2 || ssn2.length !== 7) {
      document.getElementById('ssn2').focus();
      return;
    }
    
    const postcode = document.getElementById('postcode').value.trim();
    if (!postcode) {
      document.getElementById('postcode').focus();
      return;
    }
    
    const address1 = document.getElementById('address1').value.trim();
    if (!address1) {
      document.getElementById('address1').focus();
      return;
    }
    
    const carrier = document.getElementById('carrier').value;
    if (!carrier) {
      document.getElementById('carrier').focus();
      return;
    }
    
    const phoneNumber = document.getElementById('phoneNumber').value.trim();
    if (!phoneNumber) {
      document.getElementById('phoneNumber').focus();
      return;
    }
    
    // 모든 필수 항목이 입력되어 있다면 휴대폰 번호로 포커스
    document.getElementById('phoneNumber').focus();
    return;
  }
  
  // 증권계좌번호 입력 확인
  const stockAccount = document.getElementById('stockAccount').value.trim();
  
  if (!stockAccount) {
    alert('증권계좌번호를 입력해주세요.');
    document.getElementById('stockAccount').focus();
    return;
  }
  
  // 숫자만 입력 검증
  if (!/^[0-9]+$/.test(stockAccount)) {
    alert('증권계좌번호는 숫자만 입력 가능합니다.');
    document.getElementById('stockAccount').focus();
    return;
  }
  
  // 12자리 이하 검증
  if (stockAccount.length > 12) {
    alert('증권계좌번호는 12자리 이하로 입력해주세요.');
    document.getElementById('stockAccount').focus();
    return;
  }
  
  // 백엔드 시스템 호출 (현재는 가상 테스트)
  alert('증권계좌를 조회합니다.');
  
  // TODO: 실제로는 백엔드 API를 호출하여 대출가능금액을 받아옴
  // 가상 테스트: 10000만원 설정
  document.getElementById('loanableAmount').value = '10000';
  accountLookedUp = true;
  
  // 대출가능금액 한글 표시
  const loanableKorean = numberToKorean(10000);
  document.getElementById('loanableAmountKorean').textContent = loanableKorean;
  
  // 오류 메시지 숨김
  const errorMsg = document.getElementById('stockAccountError');
  errorMsg.classList.remove('show');
  errorMsg.textContent = '';
}

/**
 * 대출 신청서 제출
 */
function submitApplication() {
  // 모든 오류 메시지 초기화
  const stockAccountError = document.getElementById('stockAccountError');
  const loanRequestAmountError = document.getElementById('loanRequestAmountError');
  const loanableAmountError = document.getElementById('loanableAmountError');
  
  stockAccountError.classList.remove('show');
  stockAccountError.textContent = '';
  loanRequestAmountError.classList.remove('show');
  loanRequestAmountError.textContent = '';
  loanableAmountError.classList.remove('show');
  loanableAmountError.textContent = '';

  // [0] 고객정보 검증 - 휴대폰 인증 완료 여부 확인
  // 휴대폰 인증 버튼에서 이미 모든 고객정보를 검증했으므로 여기서는 인증 완료만 확인
  
  // 휴대폰 인증 완료 여부 확인 (테스트용 임시 통과)
  // TODO: 실제 휴대폰 인증 API 연동 후 활성화
  /*
  if (!phoneVerified) {
    alert('휴대폰 인증을 완료해주세요.');
    document.getElementById('phoneNumber').focus();
    return;
  }
  */

  // [1] 증권계좌번호 조회 여부 확인
  if (!accountLookedUp) {
    // 대출신청금액 입력값 리셋
    document.getElementById('loanRequestAmount').value = '';
    
    // 증권계좌번호 입력 확인
    const stockAccountInput = document.getElementById('stockAccount');
    if (!stockAccountInput.value.trim()) {
      stockAccountError.textContent = '증권계좌번호를 입력해주세요.';
      stockAccountError.classList.add('show');
      stockAccountInput.focus();
      return;
    }
    
    // 오류 메시지 표시
    stockAccountError.textContent = '증권계좌번호 조회를 통해 대출가능금액을 확인해주세요.';
    stockAccountError.classList.add('show');
    
    // 증권계좌번호 라벨을 화면 중앙으로 스크롤
    const stockAccountGroup = document.getElementById('stockAccountGroup');
    const stockAccountLabel = stockAccountGroup.querySelector('.loan-form-label');
    
    setTimeout(() => {
      const labelRect = stockAccountLabel.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = scrollTop + labelRect.top - (window.innerHeight / 2) + (labelRect.height / 2);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }, 100);
    
    return;
  }

  // [2] 대출신청금액 입력 확인
  const loanRequestAmount = parseFloat(document.getElementById('loanRequestAmount').value) || 0;
  
  if (!loanRequestAmount || loanRequestAmount <= 0) {
    stockAccountError.textContent = '대출신청금액을 입력해주세요.';
    stockAccountError.classList.add('show');
    
    // 증권계좌번호 라벨을 화면 중앙으로 스크롤
    const stockAccountGroup = document.getElementById('stockAccountGroup');
    const stockAccountLabel = stockAccountGroup.querySelector('.loan-form-label');
    
    setTimeout(() => {
      const labelRect = stockAccountLabel.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = scrollTop + labelRect.top - (window.innerHeight / 2) + (labelRect.height / 2);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }, 100);
    
    return;
  }

  // [3] 대출신청금액 최소 금액 확인 (100만원)
  if (loanRequestAmount < 100) {
    const loanRequestInput = document.getElementById('loanRequestAmount');
    
    // 입력값 초기화
    loanRequestInput.value = '';
    
    // 오류 메시지 표시
    loanRequestAmountError.textContent = '최소 대출 가능 금액은 100만 원입니다.';
    loanRequestAmountError.classList.add('show');
    
    // 포커스 설정
    loanRequestInput.focus();
    
    return;
  }

  // [4] 대출신청금액과 대출가능금액 비교
  const loanableAmount = parseFloat(document.getElementById('loanableAmount').value) || 0;
  
  if (loanRequestAmount > loanableAmount) {
    // 대출신청금액 입력값 리셋
    const loanRequestInput = document.getElementById('loanRequestAmount');
    loanRequestInput.value = '';
    
    // 대출가능금액 하단에 오류 메시지 표시
    const loanableAmountError = document.getElementById('loanableAmountError');
    loanableAmountError.textContent = '대출가능금액을 확인해 주세요.';
    loanableAmountError.classList.add('show');
    
    // 대출가능금액 라벨을 화면 중앙으로 스크롤
    const loanableAmountGroup = document.querySelector('label[for="loanableAmount"]').closest('.loan-form-group');
    const loanableAmountLabel = loanableAmountGroup.querySelector('.loan-form-label');
    
    setTimeout(() => {
      const labelRect = loanableAmountLabel.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = scrollTop + labelRect.top - (window.innerHeight / 2) + (labelRect.height / 2);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      
      // 스크롤 완료 후 대출신청금액 입력폼에 포커스
      setTimeout(() => {
        loanRequestInput.focus();
      }, 500);
    }, 100);
    
    return;
  }

  // 유효성 검사 통과
  window.location.href = 'so_c2033.html';
}

/**
 * Daum 우편번호 검색 팝업 열기
 */
function openPostcodeSearch() {
  new daum.Postcode({
    oncomplete: function(data) {
      // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

      // 각 주소의 노출 규칙에 따라 주소를 조합한다.
      // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
      let addr = ''; // 주소 변수

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else { // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }

      // 우편번호와 주소 정보를 해당 필드에 넣는다.
      document.getElementById('postcode').value = data.zonecode;
      document.getElementById("address1").value = addr;
      // 커서를 상세주소 필드로 이동한다.
      document.getElementById("address2").focus();
    }
  }).open();
}

// 전역 함수로 노출
if (typeof window !== 'undefined') {
  window.numberToKorean = numberToKorean;
  window.updateKoreanAmount = updateKoreanAmount;
  window.handleEmailDomainChange = handleEmailDomainChange;
  window.verifyPhone2 = verifyPhone2;
  window.lookupStockAccount = lookupStockAccount;
  window.submitApplication = submitApplication;
  window.openPostcodeSearch = openPostcodeSearch;
  window.formatDateToKorean = formatDateToKorean;
}
